import React from "react";
import { Card, Divider, Typography, Space, Tooltip, Badge } from "antd";
import { InfoCircleOutlined, WalletOutlined, CheckCircleOutlined, DollarOutlined } from "@ant-design/icons";
import Helper from "../../core/Helper";
import { t } from "i18next";
import { useUser } from "../../core/context/UserContext";

const { Text, Title } = Typography;

export const PaymentSummaryCard = ({ payments, currency = 'TRY', totalAmount }) => {
    const { formatPrice } = useUser();

    // Toplam Ödenen Tutar
    const totalPaid = payments?.reduce((sum, p) => sum + (p.currencyAmount || 0), 0) || 0;

    // Kalan Tutar (Bakiye)
    const balance = totalAmount - totalPaid;
    const isPaid = balance <= 0;

    // Satır Bileşeni
    const SummaryRow = ({ icon, label, value, color = 'inherit', isBold = false }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <Space>
                {icon}
                <Text style={{ color: '#595959' }}>{label}</Text>
            </Space>
            <Text strong={isBold} style={{ color: color, fontSize: 15 }}>
                {formatPrice(value, { currency })}
            </Text>
        </div>
    );

    return (
        <Card
            title={<span style={{ fontSize: 12, fontWeight: 600, color: '#8c8c8c', textTransform: 'uppercase' }}>{t('Payment Summary')}</span>}
            size="small"
            bordered={false}
            style={{
                backgroundColor: '#fff',
                borderRadius: 8,
                height: '100%',
                border: '1px solid #f0f0f0'
            }}
            bodyStyle={{ padding: '20px 24px' }}
        >
            {/* Toplam Fiyat */}
            <SummaryRow
                icon={<DollarOutlined style={{ color: '#595959' }} />}
                label={t('Total Price')}
                value={totalAmount}
                isBold={true}
            />

            {/* Toplam Ödeme */}
            <SummaryRow
                icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
                label={t('Total Payment')}
                value={totalPaid}
                color="#52c41a"
                isBold={true}
            />

            <Divider style={{ margin: '16px 0' }} dashed />

            {/* Bakiye / Hesap */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: 8 }}>
                <Space>
                    <WalletOutlined style={{ color: isPaid ? '#52c41a' : '#cf1322', fontSize: 18 }} />
                    <Text strong style={{ fontSize: 16, color: '#262626' }}>{t('Account')}</Text>
                </Space>

                <div style={{ textAlign: 'right' }}>
                    <Title level={3} style={{ margin: 0, color: isPaid ? '#52c41a' : '#cf1322' }}>
                        {formatPrice(Math.abs(balance), { currency })}
                    </Title>
                    <Text type={isPaid ? 'success' : 'danger'} style={{ fontSize: 11 }}>
                        {isPaid ? t('Paid') : t('Unpaid')}
                    </Text>
                </div>
            </div>
        </Card>
    );
};